import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache the {product_id: {average, count}} aggregate for the page lifetime so
// every product card shares a single network request.
let cache = null;
let inflight = null;

export function fetchReviewsAggregate() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios
      .get(`${API}/reviews/aggregate`)
      .then((r) => { cache = r.data || {}; return cache; })
      .catch(() => ({}));
  }
  return inflight;
}

export function clearReviewsAggregateCache() {
  cache = null;
  inflight = null;
}

// Convenience hook for a single product's aggregate rating.
export function useProductRating(productId) {
  const [rating, setRating] = useState(cache ? (cache[productId] || null) : null);
  useEffect(() => {
    let mounted = true;
    fetchReviewsAggregate().then((map) => { if (mounted) setRating(map[productId] || null); });
    return () => { mounted = false; };
  }, [productId]);
  return rating;
}
